const language = {
    'pt': 
        {
            add_new:            'Adicionar novo',
            add_new_2:          'Adicionar aulas',
            back:               'Voltar',
            calendar_language:  'pt-PT',
            calendar:           'Calendário',
            calendar_allday:    'Todo o dia',
            calendar_busy:      'Ocupado',
            calendar_daynames:  ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
            calendar_free:      'Livre',
            calendar_title_placeholder:     'Assunto',
            calendar_location_placeholder:  'Localização',
            calendar_start_placeholder:     'Data de inicio',
            calendar_end_placeholder:       'Data de fim',
            calendar_save:      'Salvar',
            calendar_update:    'Atualizar',
            calendar_edit:      'Editar',
            calendar_delete:    'Apagar',
            calendar_today:     'Hoje',
            calendar_viewall:   'Ver tudo',
            calendar_month:     'Mês',
            calendar_week:      'Semana',
            calendar_day:       'Dia',
            cancel:             'Cancelar', back: 'Voltar',
            close:              'Fechar',
            config:             'Configuração',
            content:            'Conteúdo',
            content_edit:       'Editar conteúdo',
            content_new:        'Novo conteúdo',
            content_list:       'Lista de conteúdos',
            country:                'País',
            country_placeholder:    'Introduza o país',
            city:                   'Cidade',
            city_placeholder:       'Introduza a cidade',
            district:               'Distrito',
            district_placeholder:   'Introduza o distrito',
            local:                  'Localidade',
            local_placeholder:      'Introduza a localidade',
            morada:                 'Morada',
            morada_placeholder:     'Introduza a morada',
            postal_code:                'Código-postal',
            postal_code_placeholder:    'Introduza o código-postal',
            village:                'Freguesia',
            village_placeholder:    'Introduza a freguesia',
            dark_mode:          'Dark mode',
            dates:              'Datas',
            date_creation:      'Criação',
            date_publication:   'Publicação',
            date_last_update:   'Última actualização',
            delete:             'Eliminar',
            delete_title:       'Eliminar Registo',
            delete_text:        'Tem a certeza que pretende continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            description:        'Descrição',
            description_placeholder: 'Introduza uma descrição',
            edit:               'Editar',
            edit_title:         'Editar Registo',
            edit_text:          'Tem a certeza que pretende continuar?',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_error:         'Problema ao actualizar registo!',
            edit_success:       'Registo actualizado com sucesso!',
            edit_aula_title:    'Confirmar Aula',
            edit_aula_text:     'Tem a certeza que pretende continuar?',
            edit_aula_confirm:  'Confirmar',
            edit_aula_cancel:   'Voltar',
            edit_aula_deny:     'Cancelar',
            edit_aula_error:    'Problema ao actualizar registo!',
            edit_aula_success:  'Registo actualizado com sucesso!',
            email:              'E-mail', 
            email_placeholder:  'Introduza o e-mail', 
            entity:             'Instrutor',  
            entity_edit:        'Editar instrutor',                
            entity_new:         'Novo instrutor',                
            entity_list:        'Lista de instrutor', 
            filter_placeholder: 'Procurar',
            id:                 'ID',
            language:           'Lingua',
            login_data:         'Dados de login',
            name:               'Nome',
            name_placeholder:   'Introduza o nome',
            vat:                'NIF',
            vat_placeholder:    'Introduza o NIF',
            identification_number:              'Número de identificação',
            identification_number_placeholder:  'Introduza o número de identificação',
            identification_validation:          'Validade',
            image:              'Imagem',
            image_choose:       'Escolher imagem',
            insert_title:       'Novo Registo',
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao inserir registo!',
            insert_error_name:  'O nome é obrigatório.',
            insert_error_instrutor: 'O instrutor é obrigatório.',
            insert_error_category: 'A categoria é obrigatória.',
            insert_error_date:  'A data é obrigatória.',
            insert_error_horario:  'É obrigatório escolher pelo menos um horário.',
            insert_success:     'Registo inserido com sucesso!',
            password:           'Password',
            password_confirmation:  'Confirmação da Password',
            password_placeholder:   'Introduza a password',
            password_title:     'Password!',
            password_text:      'As Passwords não correspondem.',
            password_confirm:   'Continue',
            password_cancel:    'No',
            password_error:     'Problem inserting element!',
            password_success:   'Successful inserted element!', 
            personal_data:      'Dados pessoais',
            principal:          'Principal',
            profile:            'Perfil',
            remove:             'Remover',
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            table_thumbnail:    'Thumbnail',
            table_title:        'Título',
            table_parent:       'Parent',
            table_date:         'Data',
            table_type:         'Tipo',
            table_count:        'Count',
            table_state:        'Estado',
            table_actions:      'Acções',
            table_empty:        'sem resultados',
            text:               'Texto',
            title:              'Título',
            title_placeholder:  'Introduza o título',
            tlf:                'Telefone', 
            tlf_placeholder:    'Introduza o número de telefone', 
            tlm:                'Telemóvel', 
            tlm_placeholder:    'Introduza o número de telemóvel', 
            type:               'Tipo de Instrutor',
            type_placeholder:   'Introduza o tipo de Instrutor',
            aulas_type:         'Tipo',
            aulas_type_placeholder:     'Tipo',
            type_identification:                'Tipo de identificação',
            type_identification_placeholder:    'Introduza o tipo de identificação',
            save:               'Salvar', 
            scale:              'Escala',
            username:           'Username', 
            username_placeholder: 'Introduza o username', 
            warning_title:      'Aviso!',
            warning_text:       'O username já existe no sistema.',
            warning_confirm:    'Continuar',
            warning_cancel:     'Não',
            warning_error:      'Problema ao inserir registo!',
            warning_success:    'Registo inserido com sucesso!',             
        },
    'en':
        {
            add_new:            'Add new',
            add_new_2:          'Adicionar aulas',
            back:               'Voltar',
            calendar_language:  'en-GB',
            calendar:           'Calendar',
            calendar_allday:    'All day',
            calendar_busy:      'Busy',
            calendar_daynames:  ['Sun', 'Mon', 'Thu', 'Wed', 'Thr', 'Fri', 'Sat'],
            calendar_free:      'Free',
            calendar_title_placeholder:     'Subject',
            calendar_location_placeholder:  'Location',
            calendar_start_placeholder:     'Start date',
            calendar_end_placeholder:       'End date',
            calendar_save:      'Save',
            calendar_update:    'Update',
            calendar_edit:      'Edit',
            calendar_delete:    'Delete',
            calendar_today:     'Today',
            calendar_viewall:   'View all',
            calendar_month:     'Month',
            calendar_week:      'Week',
            calendar_day:       'Day',
            cancel:             'Cancel', back: 'Voltar',
            close:              'Close',
            config:              'Clonfiguration',
            content:            'Content',
            content_edit:       'Edit content',
            content_new:        'New content',
            content_list:       'Content list',
            country:                'Country',
            country_placeholder:    'Insert country',
            city:                   'Cidade',
            city_placeholder:       'Introduza a cidade',
            district:               'Distrito',
            district_placeholder:   'Insert distrito',
            local:                  'Localidade',
            local_placeholder:      'Insert localidade',
            morada:                 'Address',
            morada_placeholder:     'Insert address',
            postal_code:                'Código-postal',
            postal_code_placeholder:    'Insert código-postal',
            village:                'Freguesia',
            village_placeholder:    'Insert freguesia',
            dates:              'Dates',
            date_creation:      'Creation',
            date_publication:   'Publication',
            date_last_update:   'Last update',
            delete:             'Delete',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_error:       'Problem deleting the element!',
            delete_success:     'Element deleted successfully!',
            description:        'Description',
            description_placeholder: 'Insert a description',
            edit:               'Edit',
            edit_title:         'Edit Regist',
            edit_text:          'Are you sure you want to continue?',
            edit_confirm:       'Yes',
            edit_cancel:        'No',
            edit_error:         'Problem updating element!',
            edit_success:       'Successful updated element!',
            edit_aula_title:    'Confirmar Aula',
            edit_aula_text:     'Tem a certeza que pretende continuar?',
            edit_aula_confirm:  'Confirmar',
            edit_aula_cancel:   'Voltar',
            edit_aula_deny:     'Cancelar',
            edit_aula_error:    'Problema ao actualizar registo!',
            edit_aula_success:  'Registo actualizado com sucesso!',
            email:              'E-mail', 
            email_placeholder:  'Introduza o e-mail', 
            entity:             'Instrutor', 
            entity_edit:        'Edit instrutor', 
            entity_new:         'New instrutor', 
            entity_list:        'User List', 
            filter_placeholder: 'Search',
            id:                 'ID',
            language:           'Language',
            login_data:         'Login data',
            name:               'Name',
            name_placeholder:   'Insert the name',
            vat:                'NIF',
            vat_placeholder:    'Introduza o NIF',
            identification_number:              'Número de identificação',
            identification_number_placeholder:  'Introduza o número de identificação',
            identification_validation:          'Validade',
            image:              'Image',
            image_choose:       'Choose imagem',
            insert_title:       'New Regist',
            insert_text:        'Are you sure you want to continue?',
            insert_confirm:     'Yes',
            insert_cancel:      'No',
            insert_error:       'Problem updating element!',
            insert_error_name:  'O nome é obrigatório.',
            insert_error_instrutor: 'O instrutor é obrigatório.',
            insert_error_category: 'A categoria é obrigatória.',
            insert_error_date:  'A data é obrigatória.',
            insert_error_horario:  'É obrigatório escolher pelo menos um horário.',
            insert_success:     'Successful updated element!',
            password:           'Password',
            password_confirmation: 'Password confirmation',
            password_placeholder:   'Insert the password',
            password_text:      'The password do not match.',
            password_confirm:   'Continue',
            password_cancel:    'No',
            password_error:     'Problem inserting element!',
            password_success:   'Successful inserted element!', 
            personal_data:      'Personal data',
            principal:          'Principal',
            profile:            'Profile',
            remove:             'Remove',
            table_rows_per_page:'Regist by page:',
            table_separator:    'of',
            table_all:          'All',
            table_thumbnail:    'Thumbnail',
            table_title:        'Title',
            table_parent:       'Parent',
            table_date:         'Date',
            table_type:         'Type',
            table_count:        'Count',
            table_state:        'State',
            table_actions:      'Actions',
            table_empty:        'no results',
            text:               'Text',
            title:              'Title',
            title_placeholder:  'Insert title',
            tlf:                'Telefone', 
            tlf_placeholder:    'Introduza o número de telefone', 
            tlm:                'Telemóvel', 
            tlm_placeholder:    'Introduza o número de telemóvel', 
            type:               'Instuctor type',
            type_placeholder:   'Insert instructor type',
            aulas_type:         'Type',
            aulas_type_placeholder:     'Type',
            type_identification:                'Tipo de identificação',
            type_identification_placeholder:    'Introduza o tipo de identificação',
            save:               'Save',
            scale:              'Scale',
            username:           'Username',
            username_placeholder: 'Insert the username',
            warning_title:      'Warning!',
            warning_text:       'The username is already in the system.',
            warning_confirm:    'Continue',
            warning_cancel:     'No',
            warning_error:      'Problem inserting element!',
            warning_success:    'Successful inserted element!', 
        }
}

module.exports = {
    language
};